import { GoogleAnalyticsActions } from '../../constants';

// eslint-disable-next-line import/prefer-default-export -- we may have more functions to export
export const sendGAEvent = (eventName, label = '', category = 'User') => {
  return {
    type: GoogleAnalyticsActions.SEND_GA_EVENT,
    eventName,
    label,
    category,
  };
};

export const setUserID = (userId) => ({
  type: GoogleAnalyticsActions.SET_USER_ID,
  userId,
});
